export default {
    orders: [],
    futureOrders: [],
    photoStatuses: []
};
